import { render } from "./IngredientChecker.vue?vue&type=template&id=77ac7ec9&scoped=true"
import script from "./IngredientChecker.vue?vue&type=script&lang=js"
export * from "./IngredientChecker.vue?vue&type=script&lang=js"

import "./IngredientChecker.vue?vue&type=style&index=0&id=77ac7ec9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77ac7ec9"]])

export default __exports__